import { render, staticRenderFns } from "./CloseSaleModal.vue?vue&type=template&id=13c72d62"
import script from "./CloseSaleModal.vue?vue&type=script&lang=js"
export * from "./CloseSaleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports